import * as React from 'react';

import AvatarBadge16 from './AvatarBadge16';

export const avatarBadge16 = () => <AvatarBadge16 />;

export default {
    title: 'Icon/Line/AvatarBadge16',
    component: AvatarBadge16,
    parameters: {
        notes: "`import AvatarBadge16 from 'box-ui-elements/es/icon/line/AvatarBadge16';`",
    },
};
